import {AttributeLink} from '@acng/frontend-stargazer';

import {onClick} from '../../layout/service/worker.js';
import {getLocalAmateur} from '../../amateurPool/context/amateur.js';
import {setGlobalDialog} from '../context/global-dialog.js';
import {inject} from 'acng/core/service/ng.js';

/**
 * @group DOM Attribute
 */
const name = 'onclick-dialog';

AttributeLink(
  name,
  () => (element) =>
    onClick(element, (element) => {
      const {id, name: nickname} = getLocalAmateur(element);

      if (inject('user').guestSignup('messenger.signupRequired', {nickname})) {
        return;
      }

      setGlobalDialog(id);
    }),
);

export {name as ONCLICK_DIALOG};
